<template>
  <wrapped-component :wrap="width!=null">
    <div :class="'col-xs-'+width" #wrapper></div>
    <div class="panel" :class="(type!=null)?('panel-'+type):null">
      <div v-if="header!=null" class="panel-heading">
        <div v-if="buttons" class="pull-right">
          <div class="btn-group">
            <bbtn v-for="(btn,i) in buttons" :key="i" :type="btn.type" :hint="btn.hint" :glyph="btn.glyph" @click="btn.click" :title="btn.title"></bbtn>
          </div>
        </div>
        <wrapped-component :wrap="collapse">
          <a href="#" class="panelheader" @click.prevent="toggleCollapse(id)" #wrapper></a>
          <h3 class="centered panelheader">
            <span v-html="header"></span>
            <span v-if="badge" class="centered badge" :class="((badge==0)||(badge==''))?'default':'error'" v-html="badge"></span>
          </h3>
        </wrapped-component>
      </div>
      <div class="panel-body" v-if="!collapsed">
        <slot></slot>
      </div>
    </div>
  </wrapped-component>
</template>

<script>
export default {
  name: "IsPanel",
  props:['type','header','width','buttons','collapse','collapsed','badge'],
  data(){
    return {
      id: null
    }
  },
  methods:{
    toggleCollapse(id){
      this.collapsed=!this.collapsed;
      this.$emit("collapse",this.collapsed);
    }
  },
  mounted(){
    this.id=this._uid;
    if (this.collapsed==null) this.collapsed=false;
  }
}
</script>

<style scoped>

  div.panel-transparent
  {
    background-color: transparent;
  }

</style>